import {
  useState,
  useContext,
  createContext,
  PropsWithChildren,
} from 'react';
import dayjs from 'dayjs';
import { DATE_FORMAT } from 'utils/data';

import { getStartingDate } from './utils';

interface DateContextTypes {
  date: dayjs.Dayjs;
  dates: dayjs.Dayjs[];
  setDate: React.Dispatch<React.SetStateAction<dayjs.Dayjs>>;
  setDates: (dates: (string | undefined)[]) => void;
}

const DateContext = createContext<DateContextTypes>({
  date: getStartingDate(),
  dates: [],
  setDate() {},
  setDates() {},
});

export const useDate = () => useContext(DateContext);

export const DateProvider: React.FC<PropsWithChildren<{}>> = ({ children }) => {
  const [date, setDate] = useState<dayjs.Dayjs>(getStartingDate());
  const [dates, _setDates] = useState<dayjs.Dayjs[]>([]);

  const setDates = (dates: (string | undefined)[]): void => {
    _setDates(
      dates
        .filter((ds) => ds)
        .map((ds) => dayjs(ds, DATE_FORMAT))
        .filter((d) => d.isValid())
    );
  };

  return (
    <DateContext.Provider
      value={{
        date,
        dates,
        setDate,
        setDates,
      }}
    >
      {children}
    </DateContext.Provider>
  );
};
